import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const addGroupInvoiceAdjustment = info =>
  call(websocketFetch, 'add_group_invoice_ad_hoc_fee', info);
